import { useEffect, useState } from "react";
import { X } from "lucide-react";
import { COOKIE_CONSENT_KEY, writeFlag } from "@/lib/onboarding";

export default function CookieConsent() {
  const [open, setOpen] = useState(false);

  useEffect(() => {
    if (typeof window === "undefined") return;
    const stored = localStorage.getItem(COOKIE_CONSENT_KEY);
    if (stored) return;
    setOpen(true);
  }, []);

  const accept = () => {
    writeFlag(COOKIE_CONSENT_KEY, true);
    setOpen(false);
  };

  const reject = () => {
    writeFlag(COOKIE_CONSENT_KEY, false);
    setOpen(false);
  };

  if (!open) return null;

  return (
    <div className="fixed inset-x-0 bottom-0 z-[90] border-t border-cream-200 bg-white/95 p-4 shadow-lg backdrop-blur" role="region" aria-label="Consentimento de cookies">
      <div className="mx-auto flex max-w-7xl flex-col gap-3 sm:flex-row sm:items-center sm:justify-between">
        <div className="flex items-start gap-3">
          <img src="/logo.svg" alt="Forfada" className="h-8 w-auto" />
          <p className="text-sm text-ink-700">
            Usamos cookies e tecnologias semelhantes para melhorar sua experiência, personalizar conteúdo e analisar tráfego.
            Ao continuar navegando, você concorda com nossa{" "}
            <a href="/termos" className="font-semibold text-heat-700 underline">Política de Privacidade</a>.
          </p>
        </div>
        <div className="flex items-center gap-2">
          <button type="button" onClick={reject} className="btn-outline px-3 py-2 text-sm">Recusar</button>
          <button type="button" onClick={accept} className="btn-primary px-3 py-2 text-sm">Aceitar</button>
          <button type="button" onClick={reject} aria-label="Fechar" className="text-ink-500 hover:text-ink-900">
            <X className="h-4 w-4" />
          </button>
        </div>
      </div>
    </div>
  );
}
